/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Linked_AppleInputs */

const en_plan_linked_apple = /** @type {(inputs: Plan_Linked_AppleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You linked your payment via an apple device`)
};

const es_plan_linked_apple = /** @type {(inputs: Plan_Linked_AppleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinculaste tu pago a través de un dispositivo Apple`)
};

/**
* | output |
* | --- |
* | "You linked your payment via an apple device" |
*
* @param {Plan_Linked_AppleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_linked_apple = /** @type {((inputs?: Plan_Linked_AppleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Linked_AppleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_linked_apple(inputs)
	return en_plan_linked_apple(inputs)
});